import { cn } from '@/lib/utils';

function initialsOf(name: string) {
  return name
    .split(' ')
    .filter(Boolean)
    .map((p) => p[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

/** Initials circle. One size scale, so avatars never drift between screens. */
export function Avatar({
  name,
  size = 'md',
  className,
}: {
  name: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  const sizes = { sm: 'size-7 text-[10px]', md: 'size-8 text-xs', lg: 'size-11 text-sm' } as const;
  return (
    <span
      aria-hidden="true"
      className={cn(
        'grid shrink-0 place-items-center rounded-full bg-brand-soft font-bold text-brand',
        sizes[size],
        className,
      )}
    >
      {initialsOf(name)}
    </span>
  );
}
